import { Button } from "@/components/ui/button";
import { Plus, CalendarPlus, Clock, Eye, Pencil, Loader2, Pause, XCircle } from "lucide-react";
import { cn } from "@/lib/utils";

export type CTAState = 
  | "add_package"
  | "schedule_pickup"
  | "awaiting_approval"
  | "view_scheduled"
  | "edit_pickup"
  | "limit_reached"
  | "pending_packages"
  | "subscription_paused"
  | "subscription_expired";

interface PrimaryActionCTAProps {
  state: CTAState;
  onAction: () => void;
  className?: string;
  disabled?: boolean;
}

const CTA_CONFIG: Record<CTAState, {
  label: string;
  icon: React.ElementType;
  variant: "default" | "outline" | "secondary";
  disabled?: boolean;
}> = {
  add_package: {
    label: "Add Package",
    icon: Plus,
    variant: "default",
  },
  schedule_pickup: {
    label: "Schedule Pickup",
    icon: CalendarPlus,
    variant: "default",
  },
  awaiting_approval: {
    label: "Waiting for Approval",
    icon: Clock,
    variant: "outline",
    disabled: true,
  },
  view_scheduled: {
    label: "View Scheduled Pickup",
    icon: Eye,
    variant: "default",
  },
  edit_pickup: {
    label: "Edit Pickup Time",
    icon: Pencil,
    variant: "default",
  },
  limit_reached: {
    label: "Pickup Limit Reached",
    icon: CalendarPlus,
    variant: "outline",
    disabled: true,
  },
  pending_packages: {
    label: "Awaiting Package Approval",
    icon: Loader2,
    variant: "outline",
    disabled: true,
  },
  subscription_paused: {
    label: "Subscription Paused",
    icon: Pause,
    variant: "outline",
    disabled: true,
  },
  subscription_expired: {
    label: "Resubscribe",
    icon: XCircle,
    variant: "default",
    disabled: false,
  },
};

export const PrimaryActionCTA = ({ 
  state, 
  onAction, 
  className,
  disabled: externalDisabled 
}: PrimaryActionCTAProps) => {
  const config = CTA_CONFIG[state];
  const Icon = config.icon;
  const isDisabled = config.disabled || externalDisabled;

  return (
    <Button
      onClick={onAction}
      variant={config.variant}
      disabled={isDisabled}
      className={cn(
        "min-h-[44px] w-full sm:w-auto transition-all",
        isDisabled && "opacity-70 cursor-not-allowed",
        className
      )}
    >
      <Icon className={cn(
        "w-4 h-4 mr-2",
        state === "pending_packages" && "animate-spin"
      )} />
      {config.label}
    </Button>
  );
};
